<template>
    <zen-message-modal :isOpen="isOpen" title="Usage log" extra-wide>
        <p class="text-sm text-taupe-500 mb-4">
            {{ target?.name }}
        </p>
        <div class="max-h-[60vh] overflow-y-auto">
            <div v-if="loading" class="text-sm text-taupe-500 py-4">
                Loading usage log…
            </div>
            <div
                v-else-if="logs.length === 0"
                class="rounded-lg border border-dashed border-taupe-300 bg-taupe-50"
            >
                <zen-empty-table-message compact icon="ZenIconChartBar">
                    No usage recorded yet.
                </zen-empty-table-message>
            </div>
            <table v-else class="min-w-full divide-y divide-taupe-200 text-sm">
                <thead class="sticky top-0 z-10 bg-white shadow-xs">
                    <tr>
                        <th
                            class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                        >
                            Time
                        </th>
                        <th
                            class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                        >
                            Endpoint
                        </th>
                        <th
                            class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                        >
                            Result
                        </th>
                        <th
                            class="py-2 text-left text-xs font-medium text-taupe-500 uppercase tracking-wider"
                        >
                            IP
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-taupe-100">
                    <tr
                        v-for="log in logs"
                        :key="log.ulid"
                        class="hover:bg-taupe-50"
                    >
                        <td class="py-2 text-taupe-500 whitespace-nowrap">
                            {{ formatDateTime(log.created_at) }}
                        </td>
                        <td class="py-2 text-taupe-800 font-mono">
                            <span
                                class="inline-block rounded bg-taupe-100 px-1.5 py-0.5 text-xs mr-1"
                                >{{ log.http_method }}</span
                            >{{ log.http_path }}
                        </td>
                        <td class="py-2">
                            <span
                                :class="
                                    log.result === 'success'
                                        ? 'text-green-700 bg-green-50 ring-green-600/10'
                                        : 'text-red-700 bg-red-50 ring-red-600/10'
                                "
                                class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset"
                            >
                                {{ log.status_code }}
                            </span>
                        </td>
                        <td class="py-2 text-taupe-500 font-mono text-xs">
                            {{ log.ip_address ?? '—' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <template v-slot:buttons>
            <zen-button variant="primary" @click="$emit('close')">
                Close
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'ApiTokenUsageLogModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        target: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        logs: {
            type: Array,
            required: true,
        },
        formatDateTime: {
            type: Function,
            required: true,
        },
    },
    emits: ['close'],
}
</script>
